import {
    ROUTE_TYPE
} from './constants';

// Icons import
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import DashboardIcon from "@material-ui/icons/Dashboard";
import SettingsIcon from "@material-ui/icons/Settings";
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import DashboardFinal from "../components/dashboard/Dashboard";
import Login from "../pages/Login/Login";
import ManageUsersTable from "../components/settings/ManageUsers/ManageUsersTable";
import FileManager from "../components/filemanager/FileManager";
import SummarizeIcon from '@mui/icons-material/Summarize';
import InsightsIcon from '@mui/icons-material/Insights';
import WeeklyProfit from "../components/accounting/weeklyProfit/WeeklyProfit";
import Todo from "../components/todo/Todo";
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import ManageCompanyTable from "../components/settings/ManageCompany/ManageCompanyTable";
import StoreIcon from '@material-ui/icons/Store';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import ManageFolder from "../components/settings/ManageFolder/ManageFolder";
import LizAccounting from "../components/accounting/lizAccounting/liz/LizAccounting";
import AssignmentIcon from '@mui/icons-material/Assignment';
import ATMReceipt from "../components/accounting/lizAccounting/atm/ATMReceipt";
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import LoanReport from "../components/accounting/loanReport/LoanReport";

/**
 * {
 *  id: Route id,
 *  name: Name of route,
 *  path: location,
 *  component: React component,
 *  icon: icon name for sidebar,
 *  sidebar: show on sidebar link or no, true or false
 * }
 */

export const routes = [
    {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'login',
        label: 'Login',
        icon: VpnKeyIcon,
        path: '/login',
        component: Login,
        sidebar: false
    },
    {
        type: ROUTE_TYPE.MENU_ITEM,
        path: '/file-manager',
        component: FileManager,
        sidebar: false,
    },
]
export const protectedRoutes = [
    {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'dashboard',
        label: 'Dashboard',
        icon: DashboardIcon,
        path: '/dashboard',
        component: DashboardFinal,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'todo',
        label: 'Task',
        icon: PlaylistAddCheckIcon,
        path: '/todo',
        component: Todo,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.SUB_MENU,
        id: 'accounting',
        label: 'Accounting',
        icon: SummarizeIcon,
        sidebar: true,
        submenuItems: [
            {
                type: ROUTE_TYPE.MENU_ITEM,
                id: 'profits',
                label: 'Profits',
                icon: InsightsIcon,
                sidebar: true,
                path: '/accounting/profits',
                component: WeeklyProfit
            }
        ]
    },


    {
        type: ROUTE_TYPE.SUB_MENU,
        id: 'liz-accounting',
        label: 'Liz Accounting',
        icon: SummarizeIcon,
        sidebar: true,
        submenuItems: [
            {
                type: ROUTE_TYPE.MENU_ITEM,
                id: 'gameroom-accounting',
                label: 'GM Profits',
                icon: AssignmentIcon,
                sidebar: true,
                path: '/accounting/gameroom-accounting',
                component: LizAccounting
            },
            {
                type: ROUTE_TYPE.MENU_ITEM,
                id: 'atm',
                label: 'ATM Records',
                icon: AssignmentIcon,
                sidebar: true,
                path: '/accounting/atm-receipt',
                component: ATMReceipt
            },
             {
                type: ROUTE_TYPE.MENU_ITEM,
                id: 'loans',
                label: 'Loan Report',
                icon: LocalAtmIcon,
                sidebar: true,
                path: '/accounting/loan-report',
                component: LoanReport,
            },
        ]
    },

    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.SUB_MENU,
        id: 'settings',
        label: 'Settings',
        icon: SettingsIcon,
        sidebar: true,
        submenuItems: [
            {
                type: ROUTE_TYPE.MENU_ITEM,
                id: 'company',
                label: 'Company',
                icon: StoreIcon ,
                sidebar: true,
                path: '/settings/company',
                component: ManageCompanyTable
            },
            {
                type: ROUTE_TYPE.MENU_ITEM,
                id: 'folder',
                label: 'Folder',
                icon: FolderSpecialIcon ,
                sidebar: true,
                path: '/settings/folder',
                component: ManageFolder
            },
            {
                type: ROUTE_TYPE.MENU_ITEM,
                id: 'manage-users',
                label: 'Employee',
                icon: SupervisorAccountIcon,
                sidebar: true,
                path: '/settings/users',
                component: ManageUsersTable
            }
        ]
    },
    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
];

export const getSubmenuRoutes = (submenuItems) => {
    let submenuRoutes = [];
    submenuItems.map(item => {
        if (item.type === ROUTE_TYPE.MENU_ITEM) {
            submenuRoutes = [...submenuRoutes, item];
        } else if (item.type === ROUTE_TYPE.SUB_MENU) {
            submenuRoutes = [...submenuRoutes, ...getSubmenuRoutes(item.submenuItems)]
        }

        return item;
    });

    return submenuRoutes;
}

export const getRoutes = () => {
    return [...getSubmenuRoutes(protectedRoutes)]
}